export const FEAT_FLAG_MULTI_ITEM_BASKET = true;
export const FEAT_FLAG_EMAIL_REG = false;
export const FEAT_FLAG_EMAIL_AUTH = true;
export const FEAT_FLAG_EMAIL_RESTORE_PASS = false;
